import { Link } from '@inertiajs/react'

export default function BorrowerCallout() {
  return (
    <section className="py-16 sm:py-20 bg-[#0f1a2e]">
      <div className="max-w-[1140px] mx-auto px-8">
        <div className="rounded-2xl border border-white/10 bg-white/[0.04] backdrop-blur-sm px-8 py-10 sm:px-12 sm:py-14 text-center">
          <p className="text-[11px] font-mono uppercase tracking-[2px] text-[#34D399] font-medium mb-3">
            DebtLens
          </p>
          <h2 className="font-display text-2xl sm:text-[32px] leading-[1.2] text-white tracking-tight max-w-[520px] mx-auto mb-4">
            Are you a borrower?
          </h2>
          <p className="text-[16px] leading-relaxed text-white/60 max-w-[540px] mx-auto mb-8">
            DebtLens helps borrowers track private loans, get AI-powered exit strategies, and stay in sync with their lenders. No password needed — sign in with just your email.
          </p>
          <Link
            href="/my-loans"
            className="inline-flex items-center gap-2 px-7 py-3 bg-white/10 text-white rounded-[10px] text-[15px] font-semibold border border-white/20 hover:bg-white/15 hover:border-white/30 hover:-translate-y-0.5 transition-all"
          >
            Go to DebtLens
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M3 8h10m0 0L9 4m4 4L9 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </Link>
          <p className="mt-4 text-[13px] text-white/40">
            Free to start. No credit card required.
          </p>
        </div>
      </div>
    </section>
  )
}
